import axiosInstance from "@/utils/axiosInstance";

// Get all templates
export async function getTemplates(params = {}) {
  const { data } = await axiosInstance.get("/templates", { params });
  return data;
}

// Get single template by ID
export async function getTemplate(templateId) {
  const { data } = await axiosInstance.get(`/templates/${templateId}`);
  return data;
}

// Create new template
export async function createTemplate(payload) {
  const { data } = await axiosInstance.post("/templates", payload);
  return data;
}

// Update template
export async function updateTemplate(templateId, payload) {
  const { data } = await axiosInstance.put(`/templates/${templateId}`, payload);
  return data;
}

// Delete template
export async function deleteTemplate(templateId) {
  const { data } = await axiosInstance.delete(`/templates/${templateId}`);
  return data;
}

// Get templates by type (Appraisal, Exit Interview, PIP)
export async function getTemplatesByType(type) {
  const { data } = await axiosInstance.get("/templates", {
    params: { type },
  });
  return data;
}
